/**
 * Get the producer role for different environments based on the window location host.
 * Defaults to 'Tuottaja' for local and unknown environments.
 * @returns producer access right role's name -- string
 */
export const getProducerRoleForDifferentEnvironments = () => {
    switch (window.location.host) {
        case 'snellman-anelma3-dev.mtech.fi':
        case 'snellman-anelma3-test.mtech.fi':
            return 'Tuottaja';
        case 'snellman-anelma3-demo.mtech.fi':
            return 'Farms main user';
        case 'anelma3.snellman.fi':
        case 'snellman-anelma3.mtech.fi':
            return 'Main user - Farm'
        default:
            return `Tuottaja`;
    }
};
